import { render, staticRenderFns } from "./NoSuchEvent.vue?vue&type=template&id=1858815d&scoped=true&"
import script from "./NoSuchEvent.vue?vue&type=script&lang=js&"
export * from "./NoSuchEvent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1858815d",
  null
  
)

export default component.exports